module.exports = __webpack_public_path__ + "cbaed9ebffd2794fcd4fd5b0ce339609.pdf";